import moment from 'moment';
import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import { toLocalDateTimeStr } from 'src/shared/utils/localDateTime';
import { StringLiteralLike } from 'typescript';
import { ApprovalDetailDto, ApprovalDto, ApprovalType, FileDetailsInfo } from './approvalApi';
import { PrintTargetDocType } from './printPeriodApprovalApi';
import { RuleApproverDto } from './ruleDetailApi';
import { MethodDto, PrimaryDto, TargetScopeDto } from './userRuleApi';
const FXM_API_ENABLED = config.servers.fxm.enabled;
const FXM_API_URL = config.servers.fxm.url;
const FXM_FLAS_API_URL = config.servers.log.url;
export enum PrintType {
  ApprovalDetect = 'APPROVALDETECT',
  ApprovalMode = 'APPROVALMODE',
  PrintWat = 'PRINTWAT',
  PrintMask = 'PRINTMASK',
}
export interface UsageInfoDto {
  transId: string;
  logId: string;
  patternId: string; // 패턴 ID
  patternName: string; // 패턴 이름
  detectedCount: number; // 민감 정보 수
  detectedData: string; // 상세 정보
  exceptPattern: string; // exceptPattern 값에따라 DetectedData 출력 여부 결정
  dataDelimiter: string; // 구분 문자
}
export interface ExceptDto {
  isUsed: boolean;
  isChecked: boolean;
}
export interface ExceptServerDto {
  isUsed: string;
  isChecked: string;
}
export interface FileLogServerDto {
  file_count: number; // 전체 개수
  file_path: string; // storage 상의 파일 경로
  log_type: number; // 로그 유형 1: 인쇄 로그 2: 검출 로그
  log_date: number; // 로그 발생 시간
  file_type: number; // 1 : text(텍스트 파일) 2: png(이미지 파일)
  domain_code: string; // dsdCode
  trans_id: string; // trasnId;
  file_order: number; // 해당 인쇄 건의 파일 순서
  file_binary: string; // base64 인코딩 된 바이너리
}
export interface FileLogStatusDto {
  log_type: number; // 로그 유형 1: 인쇄 로그 2: 검출 로그
  file_type: number; // 1 : text(텍스트 파일) 2: png(이미지 파일)
  trans_id: string; // trasnId;
}
export interface FileLogServerCountDto {
  image_log_count: number;
}
export interface PrintClientRuleDetailDto extends PrimaryDto {
  targetScopeList: TargetScopeDto[];
  detectedDataCnt: number;
  approvalMode: boolean;
  approvalDetect: boolean;
  printType: string[]; // 'approvalDetect': 민감 정보 인쇄, 'approvalMode' : 인쇄 시 필수 결재, 'printWat': 인쇄 예외, 'printMask': 마스킹 인쇄
  usageInfos: UsageInfoDto[];
  exceptWat: ExceptDto;
  exceptMask: ExceptDto;
  approvalNo: string;
  applyDate: number;
  updatedTs: number;
}
export interface PrintClientApprovalDetailDto extends ApprovalDetailDto {
  printCltStatus: string; //인쇄 상태
  //   NOT_APPLIED : 인쇄 신청 전 (temp만 쌓음)
  // EXPIRED : 만료 (temp에서 신청을 안해서 시스템이 만료 처리)
  // CANCEL_APPLY : 신청 취소 (temp에서 사용자가 결재 신청을 취소함, 결재 신청 양식에서 신청 취소 버튼 클릭)
  // APPLIED : 인쇄 신청
  // CANCEL_PRINT : 인쇄 취소 (클라이언트에서 인쇄 취소 버튼 클릭)
  // PRINT : 사후 승인 인쇄 신청
  transId: string; // 출력물 인쇄 고유 ID

  isPrint: string; //인쇄 여부
  usageTime: number; //로그 시간
  receiveTime: number; //요청 시간
  clientIp: string; //클라이언트 IP
  printPageCount: number; // 인쇄 페이지 수
  printruleId: string; // ePrint rule ID
  macAddress: string; //맥 주소
  postApproval: string; //사후 결재 여부 'Y' or 'N'
  //etc 1 ~ 5 : 추가정보
  etc1: null;
  etc2: null;
  etc3: null;
  etc4: null;
  etc5: null;

  sendFlag: string; //전송 여부
  printWat: string; // 워터마크 인쇄
  printMask: string; // 마스킹 인쇄

  approvalMode: string; //인쇄 시 무조건 결재 여부 'Y' or 'N'
  exceptApp: string; // 지정 어플리케이션 예외 프로세스 명
  docType: string; //문서 종류
  //NORMAL_DOC: 일반 문서
  // SECURE_DOC: 보안 문서
  approvalDetect: string; // 검출 시 결재 여부 'Y' or 'N'
  exceptWat: string; //워터마크 예외 여부
  exceptMask: string; // 마스킹 예외 여부

  fileDetails: FileDetailsInfo[];
  usageInfos: UsageInfoDto[];
  printType: string[]; // 'approvalDetect': 민감 정보 인쇄, 'approvalMode' : 인쇄 시 필수 결재, 'printWat': 인쇄 예외, 'printMask': 마스킹 인쇄

  approvalNo: string;
  applyDate: number;
  updatedTs: number;
}
export interface LogCountDto {
  image_log_count: number;
}
export interface PrintClientApprovalDetailEntity extends PrintClientApprovalDetailDto {
  applyDateStr: string;
  updatedTsStr: string;
}
const convertPrintClientDetailDtoToEntity = (
  dto: PrintClientApprovalDetailDto
): PrintClientApprovalDetailEntity => {
  return {
    ...dto,

    applyDateStr: dto.applyDate > 0 ? toLocalDateTimeStr(dto.applyDate) : '',
    updatedTsStr: dto.updatedTs > 0 ? toLocalDateTimeStr(dto.updatedTs) : '',
  };
};
export interface PrintClientRuleDetailServerDto extends PrimaryDto {
  targetScopeList: TargetScopeDto[];
  detectedDataCnt: number;
  approvalMode: string;
  approvalDetect: string;
  printType: string[];
  usageInfos: UsageInfoDto[];
  exceptWat: ExceptServerDto;
  exceptMask: ExceptServerDto;
  approvalNo: string;
  updatedTs: number;
  applyDate: number;
}
export const defaultPrintClientRuleDetailDto = (): PrintClientRuleDetailDto => {
  return {
    code: '',
    approvalType: 'PRINTCLIENT',
    name: '',
    description: '',
    status: 'ACTIVE',
    startTs: 0,
    endTs: 0,
    limitUnit: 'DAY',
    limitApply: 0,
    applyDate: 0,
    updatedTs: 0,
    targetScopeList: [],
    detectedDataCnt: 0,
    approvalMode: false,
    approvalDetect: false,
    printType: [],
    usageInfos: [],
    exceptWat: {
      isChecked: false,
      isUsed: false,
    },
    exceptMask: {
      isChecked: false,
      isUsed: false,
    },
    approvalNo: '',
  };
};
const convertPrintClientRuleServerToDto = (
  serverDto: PrintClientRuleDetailServerDto
): PrintClientRuleDetailDto => {
  return {
    code: serverDto.code,
    approvalType: serverDto.approvalType,
    name: serverDto.name,
    description: serverDto.description,
    status: serverDto.status,
    startTs: serverDto.startTs,
    endTs: serverDto.endTs,
    limitUnit: serverDto.limitUnit,
    limitApply: serverDto.limitApply,
    approvalNo: serverDto.approvalNo,
    updatedTs: serverDto.updatedTs,
    applyDate: serverDto.applyDate,
    targetScopeList: serverDto.targetScopeList,
    detectedDataCnt: serverDto.detectedDataCnt,
    approvalMode: serverDto.approvalMode.toLocaleUpperCase() === 'Y' ? true : false,
    approvalDetect: serverDto.approvalDetect.toLocaleUpperCase() === 'Y' ? true : false,
    printType: serverDto.printType,
    usageInfos: serverDto.usageInfos,
    exceptWat: {
      isChecked: serverDto.exceptWat.isChecked.toLocaleUpperCase() === 'Y' ? true : false,
      isUsed: serverDto.exceptWat.isUsed.toLocaleUpperCase() === 'Y' ? true : false,
    },
    exceptMask: {
      isChecked: serverDto.exceptMask.isChecked.toLocaleUpperCase() === 'Y' ? true : false,
      isUsed: serverDto.exceptMask.isUsed.toLocaleUpperCase() === 'Y' ? true : false,
    },
  };
};
export interface PrintClientApprovalDto extends ApprovalDto {
  approvalNo: string;
  transId: string;
  exceptWat: boolean;
  exceptMask: boolean;
}
export type PrintClientApprovalReqDto = PrintClientApprovalDto;
export interface PrintClientApprovalServerDto extends ApprovalDto {
  approvalNo: string;
  transId: string;
  exceptWat: string;
  exceptMask: string;
}
export type PrintClientApprovalServerReqDto = PrintClientApprovalServerDto;
export const defaultPrintClientApprovalReqDto = (): PrintClientApprovalReqDto => {
  return {
    approvalNo: '',
    code: '',
    approvalStep: 1, // 신청 단계(정책에 따라 1~N까지 나뉨, 자가 승인일 경우 1)
    currentStep: 1, //신청 시 단계, 1 고정
    approvalType: ApprovalType.PRINTCLIENT,
    status: '',
    approvalMethod: '',
    remark: '',
    approvers: [],
    exceptWat: false,
    exceptMask: false,
    transId: '',
  };
};
const convertPrintClientReqDtoToServerReqDto = (
  reqDto: PrintClientApprovalReqDto
): PrintClientApprovalServerReqDto => {
  return {
    approvalNo: reqDto.approvalNo,
    code: reqDto.code,
    approvalStep: reqDto.approvalStep,
    currentStep: reqDto.currentStep,
    approvalType: reqDto.approvalType,
    status: reqDto.status,
    approvalMethod: reqDto.approvalMethod,
    remark: reqDto.remark,
    approvers: reqDto.approvers,
    exceptWat: reqDto.exceptWat ? 'Y' : 'N',
    exceptMask: reqDto.exceptMask ? 'Y' : 'N',
    transId: reqDto.transId,
  };
};
const convertPrintClientServerToDto = (
  serverDto: PrintClientApprovalServerDto
): PrintClientApprovalDto => {
  return {
    approvalNo: serverDto.approvalNo,
    code: serverDto.code,
    approvalStep: serverDto.approvalStep,
    currentStep: serverDto.currentStep,
    approvalType: serverDto.approvalType,
    status: serverDto.status,
    approvalMethod: serverDto.approvalMethod,
    remark: serverDto.remark,
    approvers: serverDto.approvers,
    exceptWat: serverDto.exceptWat === 'Y' ? true : false,
    exceptMask: serverDto.exceptMask === 'Y' ? true : false,
    transId: serverDto.transId,
  };
};
export interface LogConditionReqDto {
  header: {
    type: string;
    version: string;
  };
  body: {
    column: string[];
    condition: {
      trans_id: string;
      file_order: number;
      file_type: number;
    };
  };
}
export const defaultConditionLogReqDto = {
  header: {
    type: 'file_log',
    version: '1.2',
  },
  body: {
    column: ['file_count', 'file_order', 'file_binary', 'file_type', 'file_path'],
    condition: {
      trans_id: '151B8DBE72DD4E94BA7A9DFB962EEA00',
      log_type: 1,
      file_order: 1,
      file_type: 1,
    },
  },
};
interface PrintClientApprovalApi {
  getLogCount(transId: string): Promise<number>;
  find(code: string): Promise<PrintClientApprovalDetailEntity>;
  cancelApply(transId: string): Promise<boolean>;
  ruleDetail(transId: string): Promise<PrintClientRuleDetailDto>;
  apply(reqDto: PrintClientApprovalDto): Promise<PrintClientApprovalDto>;
  cancel(approvalNo: string): Promise<boolean>;
  findFileLog(condition): Promise<FileLogServerDto[]>;
  checkLogStatus(condition): Promise<FileLogStatusDto[]>;
}
class PrintClientApprovalServerApi implements PrintClientApprovalApi {
  async checkLogStatus(condition: any): Promise<FileLogStatusDto[]> {
    const resp = await axios.post<FileLogStatusDto[]>(`${FXM_FLAS_API_URL}`, condition);
    return resp.data;
  }
  async getLogCount(transId: string): Promise<number> {
    const reqBody = {
      header: {
        type: 'document_log',
        version: '1.2',
      },
      body: {
        column: ['image_log_count'],
        condition: {
          trans_id: transId,
        },
      },
    };
    const resp = await axios.post<FileLogServerCountDto[]>(`${FXM_FLAS_API_URL}`, reqBody);

    return resp.data[0].image_log_count;
  }
  async findFileLog(condition): Promise<FileLogServerDto[]> {
    const resp = await axios.post<FileLogServerDto[]>(`${FXM_FLAS_API_URL}`, condition);
    return resp.data;
  }
  async find(code: string): Promise<PrintClientApprovalDetailEntity> {
    const resp = await axios.get<PrintClientApprovalDetailDto>(
      `${FXM_API_URL}/api/printclient/find/${code}`
    );
    return convertPrintClientDetailDtoToEntity(resp.data);
  }
  async cancel(approvalNo: string): Promise<boolean> {
    const resp = await axios.get<PrintClientRuleDetailDto>(
      `${FXM_API_URL}/api/printclient/cancel/${approvalNo}`
    );
    if ([400, 500].includes(resp.status)) {
      return false;
    }
    return true;
  }
  async apply(reqDto: PrintClientApprovalDto): Promise<PrintClientApprovalDto> {
    const reqServerDto: PrintClientApprovalServerReqDto =
      convertPrintClientReqDtoToServerReqDto(reqDto);
    const resp = await axios.post<PrintClientApprovalServerDto>(
      `${FXM_API_URL}/api/printclient/apply`,
      reqServerDto
    );
    return convertPrintClientServerToDto(resp.data);
  }
  async ruleDetail(transId: string): Promise<PrintClientRuleDetailDto> {
    const resp = await axios.get<PrintClientRuleDetailServerDto>(
      `${FXM_API_URL}/api/printclient/applyForm/${transId}`
    );
    return convertPrintClientRuleServerToDto(resp.data);
  }
  async cancelApply(transId: string): Promise<boolean> {
    const resp = await axios.get<PrintClientRuleDetailServerDto>(
      `${FXM_API_URL}/api/printclient/cancelApply/${transId}`
    );
    if ([400, 500].includes(resp.status)) {
      return false;
    }
    return true;
  }
}
const printClientApprovalApi = new PrintClientApprovalServerApi();
export default printClientApprovalApi;
